export default __webpack_public_path__ + "static/media/validator.fee49ca9.svg";